import React, { useState, useContext } from 'react';
import Modal from '../../../../UI/Modal/Modal'
import css from './Report.module.css'
import { AppContext } from '../../../../../providers/appProvider';
import Excel from "../../../../../assets/Icon/Excel";
import PdfIcon from "../../../../../assets/Icon/PdfIcon";
import DateSelect from '../../../../UI/Inputs/DateSelect';
import { useTranslation } from 'react-i18next';


  
const Report = ({ carService }) => {
    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dates, setDates] = useState({});
    const [validationMessage, setValidationMessage] = useState("");  

    const openTableParams = () => {
        setIsModalOpen(true);
        setValidationMessage(""); 
    };

    const closeTableParams = () => {
        setIsModalOpen(false);
    };

    const report = () => {
        if (!dates.min || !dates.max) {  
            setValidationMessage(t('Selectbothdates')); 
            return;  
        }
        carService.downloadReport(dates); 
    };

    const handleMin = (date) => {
        setDates({ ...dates, min: date ? date : "" });
    };

    const handleMax = (date) => {
        setDates({ ...dates, max: date ? date : "" });
    };

    return (
        <div>

            <span className={css.exelBtn} onClick={openTableParams}>
                <span className={css.icon} > <Excel /></span>
                <span className={css.text} >{t('Report')}</span> 
            </span> 
   
            <Modal size="small" isOpen={isModalOpen} onClose={closeTableParams}>
                <div className={css.modalHead}>
                    <h3>{t('Report')}</h3>
                </div>

                <div className={css.row}>
                    <div className={css.col}>
                        <DateSelect
                            defDate={""}
                            onChange={handleMin}
                            placeholderText={t('From')}
                            popperClassName={css.dataContainer}
                            wrapperClassName={css.dataContainer}
                            className={css.input}
                            isClearable
                        />
                    </div>
                    <div className={css.col}>
                        <DateSelect
                            defDate={""}
                            onChange={handleMax}
                            placeholderText={t('To')}
                            popperClassName={css.dataContainer}
                            wrapperClassName={css.dataContainer}
                            className={css.input}
                            isClearable
                        />
                    </div>
                </div>
                 
                
                {validationMessage && <div className={css.validationMessage}>{validationMessage}</div>} {/* Step 3: Display validation message */}

                <div className={css.reportButtonContainer}>
                    <button onClick={report} className={css.btnPrimary}>{t('DownloadTheReport')}</button>
                </div>
            </Modal>
        </div>
    );
};

export default Report;
